import { createInstance, OptimizelyProvider } from '@optimizely/react-sdk'
import { PropsWithChildren } from 'react'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { getCookie } from 'utils/cookie'
import optimizelyErrorHandler from 'utils/tracking/optimizely/errorHandler'
import { isTenantSmava } from 'utils/url'

// Relies on continous internet connection in contrast to the datafile approach
export const optimizelyClient = createInstance({
  sdkKey: process.env.REACT_APP_OPTIMIZELY_SDK_KEY,
  errorHandler: optimizelyErrorHandler
})

export const TEAL_EXPERIMENT_NAME = 'alpha_ANCH_139_teal_switch_cso'

const CustomOptimizelyProvider = ({ children }: PropsWithChildren<unknown>) => {
  const { rootStore } = useRootStore()

  if (!isTenantSmava()) {
    return <>{children}</>
  }

  const userId =
    getCookie('optimizelyEndUserId') ||
    rootStore.optimizely.getOptimizelyEndUserId()

  optimizelyClient.setUser({
    id: userId
  })

  return (
    <OptimizelyProvider optimizely={optimizelyClient}>
      {children}
    </OptimizelyProvider>
  )
}

export default CustomOptimizelyProvider
